import Query from "@arcgis/core/rest/support/Query";
import { removeFromSelectionAction } from "../templates/popupTemplate/actions";
import { createMapOfGraphicsInGraphicLayer, queryLayerAddToSelectionGraphicLayer } from "../widgets/custom/select-form/spatial-select/spatialSelectVM";
import getActiveFieldsFromPopupTemplate from "./getActiveFieldsFromPopupTemplate";

const addSelectedFeatureToSelectionLayer=(view)=>{
    let layer = view.popup.selectedFeature.sourceLayer;
    let popupTemplate = layer.popupTemplate.clone();
    popupTemplate.set("actions", [removeFromSelectionAction]);
    let selectionLayer = view.map.allLayers
      .filter((layer) => layer.id === "selectionLayer")
      .getItemAt(0);
      let findDuplicateMap=createMapOfGraphicsInGraphicLayer(selectionLayer)
      const visibleFieldObjectsList=getActiveFieldsFromPopupTemplate(layer.fields,layer.popupTemplate)
      const fieldNameList=visibleFieldObjectsList.map(field=>field.name)
      fieldNameList.push("OBJECTID")
    let query: Query = new Query({
      //units: "feet",
      outFields: fieldNameList,
      returnGeometry: true,
      //spatialRelationship: "intersects",
      where: `OBJECTID = ${view.popup.selectedFeature.attributes.OBJECTID}`,
      outSpatialReference: view.spatialReference,
    });
    //may want to change this to use selectedFeature..jw 4/3/2023
    queryLayerAddToSelectionGraphicLayer(
      layer,
      query,
      popupTemplate,
      selectionLayer,
      findDuplicateMap
    );
}
export default addSelectedFeatureToSelectionLayer